import type { AdsCapabilityVariables } from '@web-platform/shared-universal-types/src/network/banana/requestTypes/adsCapabilityRequestTypes';
import type { AdsCapabilityRequestBody } from '@web-platform/shared-universal-types/src/network/types';

export const buildAdsCapabilityRequestBody = ({
  advertsConsentGiven,
  authenticated,
  cabinClass,
  creativeId,
  currency,
  deviceGuid,
  experience,
  experimentAllocationId,
  fpsSessionId,
  locale,
  market,
  platform,
  slots,
  userIntent,
  utid,
  vertical,
  viewId,
}: AdsCapabilityVariables): AdsCapabilityRequestBody => ({
  userContext: {
    utid,
    culture: { market, locale, currencyCode: currency },
    consent: { advertsConsentGiven },
    userAnalytics: { viewId, experimentAllocationId, deviceGuid, authenticated },
    platform,
  },
  searchContext: { userIntent, experience, vertical, cabinClass, fpsSessionId },
  filters: { creativeId, slots },
});
